export default __webpack_public_path__ + "static/media/webpack.c8f3bda9.png";